module.exports = __webpack_public_path__ + "img/lina.a1d3845a.jpg";